export interface TranslationLanguage {
  label: string;
  key: string;
}

export const languages: TranslationLanguage[] = [
  { key: 'en', label: 'languages.en' },
  { key: 'pl', label: 'languages.pl' },
];
